<template>
  <div v-if="this.checkMobile()" class="grey-background-container">
    <MobileNavigationBack
      :moduleRoute="moduleRoute"
      :appbarTitle="moduleRoute"
    ></MobileNavigationBack>
    <br />
    <br />

    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 mb-5 pb-2">
      <MobileBsIndex :routeDef="moduleRoute" :headersDef="headers">
      </MobileBsIndex>
    </div>

    <div
      v-if="moduleRoute === 'users'"
      class="grid grid-cols-6 gap-1 text-center mt-1 mb-1"
    >
      <!-- If users then nothing will be rendered -->
    </div>

    <div
      v-else-if="moduleRoute === 'audits'"
      class="grid grid-cols-6 gap-1 text-center mt-1 mb-1"
    >
      <!-- If audits then nothing will be rendered -->
    </div>

    <jet-nav-link
      v-else
      @click="goToCreate"
      class="fixed bottom-0 right-0 mb-4 mr-4 hover:no-underline"
    >
      <div
        class="bg-blue-500 p-3 hover:cursor-pointer rounded-full shadow"
        style="display: inline-block"
      >
        <i
          class="fas fa-plus text-white text-xl d-flex justify-content-center"
        ></i>
      </div>
    </jet-nav-link>
  </div>
  <div v-else>
    <app-layout :title="title">
      <template v-slot:sidenav> </template>

      <template v-slot:horizonav>
        <nav-bar :scId="currentProduct" scType="product"> </nav-bar>
      </template>

      <div class="mt-3">
        <PageTitle :headerTitle="title"> </PageTitle>
      </div>
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <p class="text-xs">
          We’re updating the cards and ranking all the time, so check back
          regularly.
        </p>
      </div>
      <div>
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
          <!-- cards start from here -->
          <div class="grid grid-cols-5 gap-1 my-3">
            <!-- 1 -->
            <div class="p-2" v-for="item in cardData" :key="item.id">
              <div class="group relative flex gap-x-6 rounded p-2 bg-gray-50">
                <div
                  class="mt-1 flex h-9 w-9 flex-none items-center justify-center rounded-lg bg-white"
                >
                  <svg
                    class="h-6 w-6 text-gray-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M10.5 6a7.5 7.5 0 107.5 7.5h-7.5V6z"
                    />
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M13.5 10.5H21A7.5 7.5 0 0013.5 3v7.5z"
                    />
                  </svg>
                </div>
                <div>
                  <h5 class="font-semibold text-gray-900">
                    {{ item.count }}
                    <span class="absolute inset-0"></span>
                  </h5>
                  <p class="text-gray-600 text-xs">{{ item.label }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- cards end here -->

          <div>
            <div>
              <div
                v-if="moduleRoute === 'users'"
                class="grid grid-cols-6 gap-1 text-center mt-1 mb-1"
              >
                <!-- If users then nothing will be rendered -->
              </div>

              <div
                v-else-if="moduleRoute === 'audits'"
                class="grid grid-cols-6 gap-1 text-center mt-1 mb-1"
              >
                <!-- If audits then nothing will be rendered -->
              </div>
              <div v-else>
                <div class="flex justify-between">
                  <div class="flex justify-start">
                    <div>
                      <jet-dropdown-list>
                        <template #trigger>
                          <jet-button
                            class="bg-blue-500 rounded text-white hover:bg-blue-700 hover:no-underline px-2 cursor-pointer text-sm"
                          >
                            &nbsp; {{ selectedReportLabel }}

                            <svg
                              class="ml-2 -mr-0.5 h-4 w-4"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                clip-rule="evenodd"
                              />
                            </svg>
                          </jet-button>
                        </template>

                        <template
                          #content
                          class="absolute z-50 mt-2 rounded-md shadow-lg w-48 origin-top-rounded-md ring-1 ring-black ring-opacity-5 py-1 bg-white ml-5"
                        >
                          <jet-dropdown-link
                            v-for="item in reports"
                            @click="loadReport(item)"
                            :key="item.report"
                          >
                            {{ item.label }}
                          </jet-dropdown-link>
                        </template>
                      </jet-dropdown-list>
                    </div>
                    <div>
                      <jet-button
                        class="bg-blue-500 rounded text-white hover:bg-blue-700 hover:no-underline px-2 ml-2 cursor-pointer text-sm"
                        @click="goToCreate"
                      >
                        <i class="fa fa-plus" aria-hidden="true"></i>
                        &nbsp; New {{ moduleLabel }}</jet-button
                      >
                    </div>
                  </div>

                  <div class="flex justify-start">
                    <div>
                      <LayoutSwitch
                        @layout_selected="currentLayout = $event"                        
                      ></LayoutSwitch>
                    </div>
                    <div>
                      <nav-link
                        v-if="!itemSelected"
                        class="text-gray-400 float-right hover:no-underline cursor-pointer mx-3"
                        ><i class="fa fa-trash fa-lg" aria-hidden="true"> </i>
                      </nav-link>

                      <nav-link
                        v-if="itemSelected"
                        class="text-red-500 float-right hover:no-underline cursor-pointer mx-3"
                        @click="deleteMulti"
                        ><i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                      </nav-link>
                    </div>

                    <div>
                      <nav-link
                        class="text-gray-400 float-right hover:no-underline cursor-pointer"
                        @click="refreshDatagrid"
                        ><i class="fa fa-refresh fa-lg" aria-hidden="true"> </i>
                      </nav-link>
                    </div>
                  </div>
                </div>
              </div>

              <div class="my-2">
                <div
                  class="bg-white overflow-hidden shadow-xl px-2 py-2 sm:rounded-lg"
                >
                  <BsIndex
                    v-if="currentLayout === 'list'"
                    @item_selected="OnItemSelected"
                    :routeDef="moduleRoute"
                    :slug="slug"
                    :headersDef="headers"
                    :dataRoute="dataRoute"
                    ref="bsIndexRef"
                  >
                  </BsIndex>

                  <BsIndexPivot
                    v-else-if="currentLayout === 'pivot'"
                    @item_selected="OnItemSelected"
                    :routeDef="moduleRoute"
                    :slug="slug"
                    :headersDef="pivotHeaders"
                    :dataRoute="dataRoute"
                    ref="bsIndexRef">
                  </BsIndexPivot>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-layout>
  </div>
</template>

<style>
.grey-background-container {
  background-color: #ffffff;
  height: 100%;
}
p {
  /* margin-top: 0; */
  margin-bottom: 0.1rem;
}
h5 {
  margin-bottom: 0.1rem;
}
</style>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import BsIndex from "@/Base/BsIndex.vue";
import BsIndexPivot from "@/Base/BsIndexPivot.vue";
import MobileBsIndex from "@/Base/MobileBsIndex.vue";
//import { DxDataGrid } from 'devextreme-vue/data-grid';
import DataSource from "devextreme/data/data_source";
import "devextreme/data/odata/store";
import PageTitle from "@/Layouts/PageTitle.vue";
import jetDropdownList from "@/Jetstream/DropdownList.vue";
import JetDropdownLink from "@/Jetstream/DropdownLink.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import JetButton from "@/Jetstream/Button.vue";
import MobileNavigation from "@/Layouts/MobileNavigation.vue";
import MobileNavigationBack from "@/Layouts/MobileNavigationBack.vue";
import NavBar from "../../Layouts/NavBar.vue";
import { DxButton } from "devextreme-vue/button";
import { DxToolbarItem } from "devextreme-vue/popup";
import { DxTooltip } from "devextreme-vue/tooltip";
import LayoutSwitch from "./LayoutSwitch.vue";

let collapsed = false;

export default {
  props: {
    moduleRoute: String,
    slug: String,
    currentProduct: String,
    headers: Array,
    pivotHeaders:Array,
    moduleName: String,
    moduleLabel: String,
    dataRoute: String,
    layoutType: String,
    reports: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    AppLayout,
    BsIndex,
    BsIndexPivot,
    PageTitle,
    JetNavLink,
    JetButton,
    MobileNavigation,
    MobileBsIndex,
    MobileNavigationBack,
    NavBar,
    DxButton,
    DxToolbarItem,
    DxTooltip,
    jetDropdownList,
    JetDropdownLink,
    LayoutSwitch,
  },
  data() {
    return {
      cardData: [
        { id: 1, count: 8, label: "understanding" },
        { id: 2, count: 12, label: "analysis" },
        { id: 3, count: 15, label: "research" },
        { id: 1, count: 8, label: "understanding" },
        { id: 2, count: 12, label: "analysis" },
      ],
      title: this.moduleLabel,
      currentLayout: 'list',
      appbarTitle: this.moduleRoute,
      itemSelected: false,
      selectedArr: [],
      isOpen: false,
      selectedOption: "All Items",
    };
  },
  methods: {
    
    loadReport(item) {
      console.log("Report Selected", item);
      this.$inertia.get(
        "/" + this.slug + "/" + this.moduleRoute + "/report/" + item.route
      );
    },
    filterActive() {
      console.log("Active Items selected");
    },
    filterInactive() {
      console.log("Inactive Items selected");
    },
    selectOption(option) {
      this.selectedOption = option.label;
      this.isOpen = false;
    },
    refreshDatagrid() {
      //console.log("REF IS",this.refs);
      //this.$refs['bsIndexRef'].refreshData();
      this.$refs.bsIndexRef.refreshData();
    },

    sayHelloWorld() {
      alert("Hello world!");
    },
    goToCreate() {
      this.$inertia.get("/" + this.slug + "/" + this.moduleRoute + "/create");
      //   this.$inertia.get( this.moduleRoute + '/create');
    },
    deleteMulti() {
      this.$inertia.get(
        route(this.moduleRoute + ".mutlidelete", [this.slug, this.selectedArr])
      );
    },

    checkMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        console.log("CheckMobile Called: Mobile");
        return true;
      } else {
        console.log("CheckMobile Called: Desktop");
        return false;
      }
    },

    OnItemSelected(selectedValue) {
      // console.log("On Item Selected", selectedValue);
      this.selectedArr = selectedValue;
      if (this.selectedArr.length) {
        this.itemSelected = true;
      } else {
        this.itemSelected = false;
      }

      console.log("ARR VALUE", this.selectedArr);
    },
    getLastSegment(url) {
      // Split the URL by '/' and return the last segment
      const segments = url.split("/");
      return segments.pop(); // Get the last element (i.e., 'report1')
    },
  },
  computed: {
    selectedReportLabel() {
      console.log("Reports", this.reports);
      // Find and return the label of the selected report
      const selectedReport = Object.values(this.reports).find(
        (report) => report.selected === true
      );
      return selectedReport ? selectedReport.label : "All"; // Return label if found
    },
  },
  mounted() {
    // this.checkMobile();
    //console.log("PRODC ID", this.getLastSegment(this.$page.url) );
    console.log("layout type", this.layoutType);
  },
};
</script>
